import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { ServiceItemProps } from '../types';

/**
 * Presentation component for a service item
 */
const ServiceItemPresentation: React.FC<ServiceItemProps> = ({ 
  title, 
  description, 
  icon 
}) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  
  return (
    <Box
      p={6}
      borderRadius="lg"
      boxShadow="md"
      bg={cardBg}
      borderWidth="1px"
      borderColor={borderColor}
      transition="all 0.3s"
      _hover={{
        transform: 'translateY(-5px)',
        boxShadow: 'lg',
        borderColor: 'brand.primary.base',
      }}
    >
      <VStack spacing={4} align="flex-start">
        <HStack spacing={4}>
          <Box 
            p={2} 
            borderRadius="md" 
            bg="brand.primary.base" 
            color="white"
          >
            {icon}
          </Box>
          <Heading as="h3" size="md">{title}</Heading>
        </HStack>
        <Text color="gray.600">{description}</Text>
      </VStack>
    </Box>
  );
};

export default ServiceItemPresentation;